// Saves a document ({ Name, Extension, Base64Data }) as a file in the browser
export function downloadBase64Document (documentInfo) {
  const byteCharacters = window.atob(documentInfo.Base64Data)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512)
    const byteNumbers = new Array(slice.length)

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    byteArrays.push(new Uint8Array(byteNumbers))
  }

  const blob = new Blob(byteArrays, { type: 'application/' + documentInfo.Extension })

  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = documentInfo.Name + '.' + documentInfo.Extension
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(link.href)
}
